import DataTable from "react-data-table-component";

const PreloaderTable = () => {
    const columns = [
        {
            name: 'Title',
            selector: row => row.title,
        },
        {
            name: 'Year',
            selector: row => row.year,
        },
        {
            name: 'Year',
            selector: row => row.year,
        },
        {
            name: 'Year',
            selector: row => row.year,
        },
        {
            name: 'Year',
            selector: row => row.year,
        },
        {
            name: 'Year',
            selector: row => row.year,
        },
        {
            name: 'Year',
            selector: row => row.year,
        },
        {
            name: 'Year',
            selector: row => row.year,
        },
    ];
    
    const data = [
        {
            id: 1,
            title: 'Beetlejuice',
            year: '1988',
        },
        {
            id: 2,
            title: 'Ghostbusters',
            year: '1984',
        },
        {
            id: 3,
            title: 'Ghostbusters',
            year: '1984',
        },
        {
            id: 4,
            title: 'Ghostbusters',
            year: '1984',
        },
        {
            id: 5,
            title: 'Ghostbusters',
            year: '1984',
        },
        {
            id: 6,
            title: 'Ghostbusters',
            year: '1984',
        },
        {
            id: 7,
            title: 'Ghostbusters',
            year: '1984',
        },
        {
            id: 8,
            title: 'Ghostbusters',
            year: '1984',
        },
        {
            id: 9,
            title: 'Ghostbusters',
            year: '1984',
        },
        {
            id: 10,
            title: 'Ghostbusters',
            year: '1984',
        },
    ];

    return (
        <div className="w-full relative bg-white">
            <DataTable
                columns={columns}
                className="invisible"
                data={ data }
                noHeader
                defaultSortField="id"
                defaultSortAsc={false}
                highlightOnHover
                responsive
                noDataComponent={<div className="my-5">No hay registros</div>}
            />
            <div className={ `w-full flex justify-center items-center absolute top-0 left-0 right-0 bottom-0 m-auto z-40` }>
                <div className="bg-Turquesa p-2 w-4 h-4 rounded-full animate-bounce animate-delay-100 m-1"></div>
                <div className="bg-Turquesa p-2 w-4 h-4 rounded-full animate-bounce animate-delay-200 m-1"></div>
                <div className="bg-Turquesa p-2 w-4 h-4 rounded-full animate-bounce animate-delay-300 m-1"></div>
            </div>
            <div className="top-0 absolute w-full h-12 bg-Turquesa"></div>
        </div>
    );
}

export default PreloaderTable;
